import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cn } from '../../../../utils/cn';
import { formatDetailsForMarkdown } from '../parsers/details-block';

export const MessageDetailsPanel = ({
  messageId,
  detailsContent,
  detailsStreamingPartial,
}: {
  messageId: string;
  detailsContent: string | null;
  detailsStreamingPartial: boolean;
}) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  useEffect(() => {
    setDetailsOpen(false);
  }, [messageId]);

  if (!detailsContent) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={() => setDetailsOpen((prev) => !prev)}
        className={cn(
          'self-start rounded-sm border border-brand-blue px-3 py-1.5 text-xs uppercase tracking-wide',
          'text-brand-blue transition-colors hover:bg-brand-blue hover:text-white',
        )}
      >
        {detailsOpen ? 'Dolj detaljer' : 'Visa detaljer'}
      </button>
      {detailsOpen ? (
        <div className="rounded-sm border border-black/10 bg-white p-3 text-sm text-brand-blue">
          {detailsStreamingPartial ? (
            <div className="whitespace-pre-wrap">{detailsContent}</div>
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {formatDetailsForMarkdown(detailsContent)}
            </ReactMarkdown>
          )}
        </div>
      ) : null}
    </div>
  );
};
